import * as yup from 'yup';

export const schema:any = yup.object().shape({
  invoice: yup.string().required('The Invoice field is required.').matches(/^[a-zA-Z0-9]*$/, 'The Invoice field must be letters and numbers only.'),
  amount: yup.number().typeError('The Amount field must be a number.').nullable().positive('The Amount field must be a number.')
    .required('The Amount field is required.')
});
